var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:`mobileBack ${_vm.type}`},[_c('div',{staticClass:"backIcon",on:{"click":_vm.clickBack}})])
}
var staticRenderFns = []

export { render, staticRenderFns }